export const SPORTS = [
	{
		label: 'baseball',
		value: 'baseball',
	},
	{
		label: 'basketball',
		value: 'basketball',
	},
	{
		label: 'cricket',
		value: 'cricket',
	},
	{
		label: 'esports',
		value: 'esports',
	},
	{
		label: 'football',
		value: 'football',
	},
	{
		label: 'golf',
		value: 'golf',
	},
	{
		label: 'hockey',
		value: 'hockey',
	},
	{
		label: 'mma',
		value: 'mma',
	},
	{
		label: 'soccer',
		value: 'soccer',
	},
	{
		label: 'tennis',
		value: 'tennis',
	},
];

export const LEAGUES = [
	{ label: 'ATP', value: 'ATP' },
	{ label: 'ATP Challenger', value: 'ATP Challenger' },
	{
		label: 'Argentina - Primera Division',
		value: 'Argentina - Primera Division',
	},
	{
		label: 'Argentina - Primera Nacional',
		value: 'Argentina - Primera Nacional',
	},
	{ label: 'Australia - A-League', value: 'Australia - A-League' },
	{ label: 'Australia - NBL', value: 'Australia - NBL' },
	{ label: 'Austria - 2. Liga', value: 'Austria - 2. Liga' },
	{ label: 'Austria - Bundesliga', value: 'Austria - Bundesliga' },
	{
		label: 'Belarus - Premier League',
		value: 'Belarus - Premier League',
	},
	{
		label: 'Belgium - Jupiler Pro League',
		value: 'Belgium - Jupiler Pro League',
	},
	{
		label: 'Brazil - Copa do Brasil',
		value: 'Brazil - Copa do Brasil',
	},
	{ label: 'Brazil - Serie A', value: 'Brazil - Serie A' },
	{ label: 'Brazil - Serie B', value: 'Brazil - Serie B' },
	{ label: 'Brazil - Serie C', value: 'Brazil - Serie C' },
	{ label: 'CFL', value: 'CFL' },
	{
		label: 'CONMEBOL - Copa Libertadores',
		value: 'CONMEBOL - Copa Libertadores',
	},
	{
		label: 'CONMEBOL - Copa Sudamericana',
		value: 'CONMEBOL - Copa Sudamericana',
	},
	{ label: 'CPBL', value: 'CPBL' },
	{ label: 'CS2', value: 'CS2' },
	{
		label: 'Canada - Premier League',
		value: 'Canada - Premier League',
	},
	{
		label: 'Chile - Primera Division',
		value: 'Chile - Primera Division',
	},
	{ label: 'China - CBA', value: 'China - CBA' },
	{ label: 'China - League One', value: 'China - League One' },
	{ label: 'China - League Two', value: 'China - League Two' },
	{ label: 'China - Super League', value: 'China - Super League' },
	{ label: 'Colombia - Primera A', value: 'Colombia - Primera A' },
	{ label: 'Colombia - Primera B', value: 'Colombia - Primera B' },
	{ label: 'Croatia - 1. HNL', value: 'Croatia - 1. HNL' },
	{ label: 'Czech Republic - FNL', value: 'Czech Republic - FNL' },
	{ label: 'Denmark - Superliga', value: 'Denmark - Superliga' },
	{ label: 'Dota 2', value: 'Dota 2' },
	{ label: 'Ecuador - Serie B', value: 'Ecuador - Serie B' },
	{ label: 'England - Championship', value: 'England - Championship' },
	{ label: 'England - League 1', value: 'England - League 1' },
	{ label: 'England - League 2', value: 'England - League 2' },
	{
		label: 'England - National League',
		value: 'England - National League',
	},
	{
		label: 'England - Premier League',
		value: 'England - Premier League',
	},
	{ label: 'Estonia - Esiliiga', value: 'Estonia - Esiliiga' },
	{ label: 'Estonia - Esiliiga B', value: 'Estonia - Esiliiga B' },
	{ label: 'Euroleague', value: 'Euroleague' },
	{ label: 'FIFA - World Cup', value: 'FIFA - World Cup' },
	{
		label: 'Finland - Veikkausliiga',
		value: 'Finland - Veikkausliiga',
	},
	{ label: 'Finland - Ykkonen', value: 'Finland - Ykkonen' },
	{ label: 'Finland - Ykkosliiga', value: 'Finland - Ykkosliiga' },
	{ label: 'France - LNB Pro A', value: 'France - LNB Pro A' },
	{ label: 'France - Ligue 1', value: 'France - Ligue 1' },
	{ label: 'France - Ligue 2', value: 'France - Ligue 2' },
	{ label: 'Germany - BBL', value: 'Germany - BBL' },
	{ label: 'Germany - Bundesliga', value: 'Germany - Bundesliga' },
	{ label: 'Germany - Bundesliga 2', value: 'Germany - Bundesliga 2' },
	{ label: 'Germany - Bundesliga 3', value: 'Germany - Bundesliga 3' },
	{ label: 'Greece - Super League', value: 'Greece - Super League' },
	{
		label: 'Greece - Super League 2',
		value: 'Greece - Super League 2',
	},
	{
		label: 'Guatemala - Liga Nacional',
		value: 'Guatemala - Liga Nacional',
	},
	{ label: 'Hungary - NB I', value: 'Hungary - NB I' },
	{ label: 'India - Super League', value: 'India - Super League' },
	{ label: 'International - Tours', value: 'International - Tours' },
	{
		label: 'International - Tours Women',
		value: 'International - Tours Women',
	},
	{ label: 'Ireland - Division 1', value: 'Ireland - Division 1' },
	{
		label: 'Ireland - Premier League',
		value: 'Ireland - Premier League',
	},
	{
		label: 'Israel - Premier League',
		value: 'Israel - Premier League',
	},
	{
		label: 'Italy - Lega Basket Serie A',
		value: 'Italy - Lega Basket Serie A',
	},
	{ label: 'Italy - Serie A', value: 'Italy - Serie A' },
	{ label: 'Italy - Serie B', value: 'Italy - Serie B' },
	{ label: 'Italy - Serie C', value: 'Italy - Serie C' },
	{ label: 'Japan - J1 League', value: 'Japan - J1 League' },
	{ label: 'Japan - J2 League', value: 'Japan - J2 League' },
	{ label: 'Japan - J3 League', value: 'Japan - J3 League' },
	{ label: 'KBO', value: 'KBO' },
	{
		label: 'Kazakhstan - Premier League',
		value: 'Kazakhstan - Premier League',
	},
	{ label: 'Korea - K1 League', value: 'Korea - K1 League' },
	{ label: 'Korea - K2 League', value: 'Korea - K2 League' },
	{ label: 'Korea - K3 League', value: 'Korea - K3 League' },
	{ label: 'Korea - KBL', value: 'Korea - KBL' },
	{ label: 'Latvia - Virsliga', value: 'Latvia - Virsliga' },
	{ label: 'League of Legends', value: 'League of Legends' },
	{ label: 'Lithuania - 1 Lyga', value: 'Lithuania - 1 Lyga' },
	{ label: 'Lithuania - A Lyga', value: 'Lithuania - A Lyga' },
	{ label: 'MLB', value: 'MLB' },
	{
		label: 'Malaysia - Super League',
		value: 'Malaysia - Super League',
	},
	{ label: 'Mexico - Liga MX', value: 'Mexico - Liga MX' },
	{
		label: 'Mexico - Liga de Expansion MX',
		value: 'Mexico - Liga de Expansion MX',
	},
	{
		label: 'Mongolia - Premier League',
		value: 'Mongolia - Premier League',
	},
	{ label: 'NBA', value: 'NBA' },
	{ label: 'NCAAB', value: 'NCAAB' },
	{ label: 'NCAAF', value: 'NCAAF' },
	{ label: 'NCAAH', value: 'NCAAH' },
	{ label: 'NFL', value: 'NFL' },
	{ label: 'NHL', value: 'NHL' },
	{ label: 'NPB', value: 'NPB' },
	{
		label: 'Netherlands - Eerste Divisie',
		value: 'Netherlands - Eerste Divisie',
	},
	{
		label: 'Netherlands - Eredivisie',
		value: 'Netherlands - Eredivisie',
	},
	{ label: 'Norway - 1. Divisjon', value: 'Norway - 1. Divisjon' },
	{ label: 'Norway - Eliteserien', value: 'Norway - Eliteserien' },
	{ label: 'PGA', value: 'PGA' },
	{ label: 'Poland - Ekstraklasa', value: 'Poland - Ekstraklasa' },
	{ label: 'Poland - I Liga', value: 'Poland - I Liga' },
	{
		label: 'Portugal - Primeira Liga',
		value: 'Portugal - Primeira Liga',
	},
	{
		label: 'Portugal - Segunda Liga',
		value: 'Portugal - Segunda Liga',
	},
	{ label: 'Rocket League', value: 'Rocket League' },
	{ label: 'Romania - Liga I', value: 'Romania - Liga I' },
	{ label: 'Romania - Liga II', value: 'Romania - Liga II' },
	{
		label: 'Russia - Premier League',
		value: 'Russia - Premier League',
	},
	{
		label: 'Saudi Arabia - Saudi League',
		value: 'Saudi Arabia - Saudi League',
	},
	{
		label: 'Scotland - Championship',
		value: 'Scotland - Championship',
	},
	{ label: 'Scotland - Premiership', value: 'Scotland - Premiership' },
	{ label: 'Serbia - Super Liga', value: 'Serbia - Super Liga' },
	{
		label: 'Singapore - Premier League',
		value: 'Singapore - Premier League',
	},
	{ label: 'Spain - LEB Oro', value: 'Spain - LEB Oro' },
	{ label: 'Spain - La Liga', value: 'Spain - La Liga' },
	{ label: 'Spain - La Liga 2', value: 'Spain - La Liga 2' },
	{ label: 'Spain - Liga ACB', value: 'Spain - Liga ACB' },
	{ label: 'Sweden - Allsvenskan', value: 'Sweden - Allsvenskan' },
	{ label: 'Sweden - Ettan', value: 'Sweden - Ettan' },
	{ label: 'Sweden - Superettan', value: 'Sweden - Superettan' },
	{
		label: 'Switzerland - Challenge League',
		value: 'Switzerland - Challenge League',
	},
	{
		label: 'Switzerland - Super League',
		value: 'Switzerland - Super League',
	},
	{ label: 'Turkey - 1. Lig', value: 'Turkey - 1. Lig' },
	{ label: 'Turkey - Super Lig', value: 'Turkey - Super Lig' },
	{
		label: 'UEFA - Champions League',
		value: 'UEFA - Champions League',
	},
	{
		label: 'UEFA - Europa Conference League',
		value: 'UEFA - Europa Conference League',
	},
	{ label: 'UEFA - Europa League', value: 'UEFA - Europa League' },
	{ label: 'UFC', value: 'UFC' },
	{ label: 'USA - MLS Next Pro', value: 'USA - MLS Next Pro' },
	{
		label: 'USA - Major League Soccer',
		value: 'USA - Major League Soccer',
	},
	{ label: 'USA - NISA', value: 'USA - NISA' },
	{ label: 'USA - NWSL', value: 'USA - NWSL' },
	{ label: 'USA - USL Championship', value: 'USA - USL Championship' },
	{ label: 'USA - USL League One', value: 'USA - USL League One' },
	{
		label: 'Ukraine - Premier League',
		value: 'Ukraine - Premier League',
	},
	{
		label: 'Uruguay - Primera Division',
		value: 'Uruguay - Primera Division',
	},
	{
		label: 'Uruguay - Segunda Division',
		value: 'Uruguay - Segunda Division',
	},
	{
		label: 'Uzbekistan - Super League',
		value: 'Uzbekistan - Super League',
	},
	{ label: 'Valorant', value: 'Valorant' },
	{ label: 'Vietnam - V League 1', value: 'Vietnam - V League 1' },
	{ label: 'WNBA', value: 'WNBA' },
	{ label: 'WTA', value: 'WTA' },
];

export const LEAGUES_CATEGORIZED = [
	{
		label: 'CPBL',
		value: 'CPBL',
		sport: 'baseball',
	},
	{
		label: 'KBO',
		value: 'KBO',
		sport: 'baseball',
	},
	{
		label: 'MLB',
		value: 'MLB',
		sport: 'baseball',
	},
	{
		label: 'NPB',
		value: 'NPB',
		sport: 'baseball',
	},
	{
		label: 'China - CBA',
		value: 'China - CBA',
		sport: 'basketball',
	},
	{
		label: 'France - LNB Pro A',
		value: 'France - LNB Pro A',
		sport: 'basketball',
	},
	{
		label: 'Germany - BBL',
		value: 'Germany - BBL',
		sport: 'basketball',
	},
	{
		label: 'Italy - Lega Basket Serie A',
		value: 'Italy - Lega Basket Serie A',
		sport: 'basketball',
	},
	{
		label: 'NBA',
		value: 'NBA',
		sport: 'basketball',
	},
	{
		label: 'NCAAB',
		value: 'NCAAB',
		sport: 'basketball',
	},
	{
		label: 'Spain - Liga ACB',
		value: 'Spain - Liga ACB',
		sport: 'basketball',
	},
	{
		label: 'Argentina - Primera Division',
		value: 'Argentina - Primera Division',
		sport: 'soccer',
	},
	{
		label: 'Austria - Bundesliga',
		value: 'Austria - Bundesliga',
		sport: 'soccer',
	},
	{
		label: 'Belarus - Premier League',
		value: 'Belarus - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Brazil - Serie A',
		value: 'Brazil - Serie A',
		sport: 'soccer',
	},
	{
		label: 'Brazil - Serie B',
		value: 'Brazil - Serie B',
		sport: 'soccer',
	},
	{
		label: 'Brazil - Serie C',
		value: 'Brazil - Serie C',
		sport: 'soccer',
	},
	{
		label: 'Canada - Premier League',
		value: 'Canada - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Chile - Primera Division',
		value: 'Chile - Primera Division',
		sport: 'soccer',
	},
	{
		label: 'China - Super League',
		value: 'China - Super League',
		sport: 'soccer',
	},
	{
		label: 'Ecuador - Serie B',
		value: 'Ecuador - Serie B',
		sport: 'soccer',
	},
	{
		label: 'England - Championship',
		value: 'England - Championship',
		sport: 'soccer',
	},
	{
		label: 'England - League 1',
		value: 'England - League 1',
		sport: 'soccer',
	},
	{
		label: 'England - League 2',
		value: 'England - League 2',
		sport: 'soccer',
	},
	{
		label: 'England - Premier League',
		value: 'England - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Finland - Veikkausliiga',
		value: 'Finland - Veikkausliiga',
		sport: 'soccer',
	},
	{
		label: 'Finland - Ykkonen',
		value: 'Finland - Ykkonen',
		sport: 'soccer',
	},
	{
		label: 'Finland - Ykkosliiga',
		value: 'Finland - Ykkosliiga',
		sport: 'soccer',
	},
	{
		label: 'France - Ligue 1',
		value: 'France - Ligue 1',
		sport: 'soccer',
	},
	{
		label: 'France - Ligue 2',
		value: 'France - Ligue 2',
		sport: 'soccer',
	},
	{
		label: 'Germany - Bundesliga',
		value: 'Germany - Bundesliga',
		sport: 'soccer',
	},
	{
		label: 'Germany - Bundesliga 2',
		value: 'Germany - Bundesliga 2',
		sport: 'soccer',
	},
	{
		label: 'Germany - Bundesliga 3',
		value: 'Germany - Bundesliga 3',
		sport: 'soccer',
	},
	{
		label: 'Greece - Super League',
		value: 'Greece - Super League',
		sport: 'soccer',
	},
	{
		label: 'Greece - Super League 2',
		value: 'Greece - Super League 2',
		sport: 'soccer',
	},
	{
		label: 'India - Super League',
		value: 'India - Super League',
		sport: 'soccer',
	},
	{
		label: 'Ireland - Division 1',
		value: 'Ireland - Division 1',
		sport: 'soccer',
	},
	{
		label: 'Ireland - Premier League',
		value: 'Ireland - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Israel - Premier League',
		value: 'Israel - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Italy - Serie A',
		value: 'Italy - Serie A',
		sport: 'soccer',
	},
	{
		label: 'Italy - Serie B',
		value: 'Italy - Serie B',
		sport: 'soccer',
	},
	{
		label: 'Italy - Serie C',
		value: 'Italy - Serie C',
		sport: 'soccer',
	},
	{
		label: 'Kazakhstan - Premier League',
		value: 'Kazakhstan - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Malaysia - Super League',
		value: 'Malaysia - Super League',
		sport: 'soccer',
	},
	{
		label: 'Mexico - Liga MX',
		value: 'Mexico - Liga MX',
		sport: 'soccer',
	},
	{
		label: 'Mongolia - Premier League',
		value: 'Mongolia - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Netherlands - Eerste Divisie',
		value: 'Netherlands - Eerste Divisie',
		sport: 'soccer',
	},
	{
		label: 'Netherlands - Eredivisie',
		value: 'Netherlands - Eredivisie',
		sport: 'soccer',
	},
	{
		label: 'Norway - Eliteserien',
		value: 'Norway - Eliteserien',
		sport: 'soccer',
	},
	{
		label: 'Poland - Ekstraklasa',
		value: 'Poland - Ekstraklasa',
		sport: 'soccer',
	},
	{
		label: 'Romania - Liga I',
		value: 'Romania - Liga I',
		sport: 'soccer',
	},
	{
		label: 'Romania - Liga II',
		value: 'Romania - Liga II',
		sport: 'soccer',
	},
	{
		label: 'Russia - Premier League',
		value: 'Russia - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Scotland - Championship',
		value: 'Scotland - Championship',
		sport: 'soccer',
	},
	{
		label: 'Singapore - Premier League',
		value: 'Singapore - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Spain - La Liga',
		value: 'Spain - La Liga',
		sport: 'soccer',
	},
	{
		label: 'Spain - La Liga 2',
		value: 'Spain - La Liga 2',
		sport: 'soccer',
	},
	{
		label: 'Sweden - Allsvenskan',
		value: 'Sweden - Allsvenskan',
		sport: 'soccer',
	},
	{
		label: 'Switzerland - Super League',
		value: 'Switzerland - Super League',
		sport: 'soccer',
	},
	{
		label: 'USA - MLS Next Pro',
		value: 'USA - MLS Next Pro',
		sport: 'soccer',
	},
	{
		label: 'USA - USL Championship',
		value: 'USA - USL Championship',
		sport: 'soccer',
	},
	{
		label: 'USA - USL League One',
		value: 'USA - USL League One',
		sport: 'soccer',
	},
	{
		label: 'Ukraine - Premier League',
		value: 'Ukraine - Premier League',
		sport: 'soccer',
	},
	{
		label: 'Uruguay - Primera Division',
		value: 'Uruguay - Primera Division',
		sport: 'soccer',
	},
	{
		label: 'Uruguay - Segunda Division',
		value: 'Uruguay - Segunda Division',
		sport: 'soccer',
	},
	{
		label: 'Uzbekistan - Super League',
		value: 'Uzbekistan - Super League',
		sport: 'soccer',
	},
	{
		label: 'Vietnam - V League 1',
		value: 'Vietnam - V League 1',
		sport: 'soccer',
	},
	{
		label: 'ATP',
		value: 'ATP',
		sport: 'other',
	},
	{
		label: 'ATP Challenger',
		value: 'ATP Challenger',
		sport: 'other',
	},
	{
		label: 'Argentina - Primera Nacional',
		value: 'Argentina - Primera Nacional',
		sport: 'other',
	},
	{
		label: 'Australia - A-League',
		value: 'Australia - A-League',
		sport: 'other',
	},
	{
		label: 'Australia - NBL',
		value: 'Australia - NBL',
		sport: 'other',
	},
	{
		label: 'Austria - 2. Liga',
		value: 'Austria - 2. Liga',
		sport: 'other',
	},
	{
		label: 'Belgium - Jupiler Pro League',
		value: 'Belgium - Jupiler Pro League',
		sport: 'other',
	},
	{
		label: 'Brazil - Copa do Brasil',
		value: 'Brazil - Copa do Brasil',
		sport: 'other',
	},
	{
		label: 'CFL',
		value: 'CFL',
		sport: 'other',
	},
	{
		label: 'CONMEBOL - Copa Libertadores',
		value: 'CONMEBOL - Copa Libertadores',
		sport: 'other',
	},
	{
		label: 'CONMEBOL - Copa Sudamericana',
		value: 'CONMEBOL - Copa Sudamericana',
		sport: 'other',
	},
	{
		label: 'CS2',
		value: 'CS2',
		sport: 'other',
	},
	{
		label: 'China - League One',
		value: 'China - League One',
		sport: 'other',
	},
	{
		label: 'China - League Two',
		value: 'China - League Two',
		sport: 'other',
	},
	{
		label: 'Colombia - Primera A',
		value: 'Colombia - Primera A',
		sport: 'other',
	},
	{
		label: 'Colombia - Primera B',
		value: 'Colombia - Primera B',
		sport: 'other',
	},
	{
		label: 'Croatia - 1. HNL',
		value: 'Croatia - 1. HNL',
		sport: 'other',
	},
	{
		label: 'Czech Republic - FNL',
		value: 'Czech Republic - FNL',
		sport: 'other',
	},
	{
		label: 'Denmark - Superliga',
		value: 'Denmark - Superliga',
		sport: 'other',
	},
	{
		label: 'Dota 2',
		value: 'Dota 2',
		sport: 'other',
	},
	{
		label: 'England - National League',
		value: 'England - National League',
		sport: 'other',
	},
	{
		label: 'Estonia - Esiliiga',
		value: 'Estonia - Esiliiga',
		sport: 'other',
	},
	{
		label: 'Estonia - Esiliiga B',
		value: 'Estonia - Esiliiga B',
		sport: 'other',
	},
	{
		label: 'FIFA - World Cup',
		value: 'FIFA - World Cup',
		sport: 'other',
	},
	{
		label: 'Guatemala - Liga Nacional',
		value: 'Guatemala - Liga Nacional',
		sport: 'other',
	},
	{
		label: 'Hungary - NB I',
		value: 'Hungary - NB I',
		sport: 'other',
	},
	{
		label: 'International - Tours',
		value: 'International - Tours',
		sport: 'other',
	},
	{
		label: 'International - Tours Women',
		value: 'International - Tours Women',
		sport: 'other',
	},
	{
		label: 'Japan - J1 League',
		value: 'Japan - J1 League',
		sport: 'other',
	},
	{
		label: 'Japan - J2 League',
		value: 'Japan - J2 League',
		sport: 'other',
	},
	{
		label: 'Japan - J3 League',
		value: 'Japan - J3 League',
		sport: 'other',
	},
	{
		label: 'Korea - K1 League',
		value: 'Korea - K1 League',
		sport: 'other',
	},
	{
		label: 'Korea - K2 League',
		value: 'Korea - K2 League',
		sport: 'other',
	},
	{
		label: 'Korea - K3 League',
		value: 'Korea - K3 League',
		sport: 'other',
	},
	{
		label: 'Korea - KBL',
		value: 'Korea - KBL',
		sport: 'other',
	},
	{
		label: 'Latvia - Virsliga',
		value: 'Latvia - Virsliga',
		sport: 'other',
	},
	{
		label: 'League of Legends',
		value: 'League of Legends',
		sport: 'other',
	},
	{
		label: 'Lithuania - 1 Lyga',
		value: 'Lithuania - 1 Lyga',
		sport: 'other',
	},
	{
		label: 'Lithuania - A Lyga',
		value: 'Lithuania - A Lyga',
		sport: 'other',
	},
	{
		label: 'Mexico - Liga de Expansion MX',
		value: 'Mexico - Liga de Expansion MX',
		sport: 'other',
	},
	{
		label: 'NCAAF',
		value: 'NCAAF',
		sport: 'other',
	},
	{
		label: 'NCAAH',
		value: 'NCAAH',
		sport: 'other',
	},
	{
		label: 'NFL',
		value: 'NFL',
		sport: 'other',
	},
	{
		label: 'NHL',
		value: 'NHL',
		sport: 'other',
	},
	{
		label: 'Norway - 1. Divisjon',
		value: 'Norway - 1. Divisjon',
		sport: 'other',
	},
	{
		label: 'PGA',
		value: 'PGA',
		sport: 'other',
	},
	{
		label: 'Poland - I Liga',
		value: 'Poland - I Liga',
		sport: 'other',
	},
	{
		label: 'Portugal - Primeira Liga',
		value: 'Portugal - Primeira Liga',
		sport: 'other',
	},
	{
		label: 'Portugal - Segunda Liga',
		value: 'Portugal - Segunda Liga',
		sport: 'other',
	},
	{
		label: 'Rocket League',
		value: 'Rocket League',
		sport: 'other',
	},
	{
		label: 'Saudi Arabia - Saudi League',
		value: 'Saudi Arabia - Saudi League',
		sport: 'other',
	},
	{
		label: 'Scotland - Premiership',
		value: 'Scotland - Premiership',
		sport: 'other',
	},
	{
		label: 'Serbia - Super Liga',
		value: 'Serbia - Super Liga',
		sport: 'other',
	},
	{
		label: 'Spain - LEB Oro',
		value: 'Spain - LEB Oro',
		sport: 'other',
	},
	{
		label: 'Sweden - Ettan',
		value: 'Sweden - Ettan',
		sport: 'other',
	},
	{
		label: 'Sweden - Superettan',
		value: 'Sweden - Superettan',
		sport: 'other',
	},
	{
		label: 'Switzerland - Challenge League',
		value: 'Switzerland - Challenge League',
		sport: 'other',
	},
	{
		label: 'Turkey - 1. Lig',
		value: 'Turkey - 1. Lig',
		sport: 'other',
	},
	{
		label: 'Turkey - Super Lig',
		value: 'Turkey - Super Lig',
		sport: 'other',
	},
	{
		label: 'UEFA - Champions League',
		value: 'UEFA - Champions League',
		sport: 'other',
	},
	{
		label: 'UEFA - Europa Conference League',
		value: 'UEFA - Europa Conference League',
		sport: 'other',
	},
	{
		label: 'UEFA - Europa League',
		value: 'UEFA - Europa League',
		sport: 'other',
	},
	{
		label: 'UFC',
		value: 'UFC',
		sport: 'other',
	},
	{
		label: 'USA - Major League Soccer',
		value: 'USA - Major League Soccer',
		sport: 'other',
	},
	{
		label: 'USA - NISA',
		value: 'USA - NISA',
		sport: 'other',
	},
	{
		label: 'USA - NWSL',
		value: 'USA - NWSL',
		sport: 'other',
	},
	{
		label: 'Valorant',
		value: 'Valorant',
		sport: 'other',
	},
	{
		label: 'WTA',
		value: 'WTA',
		sport: 'other',
	},
];

export const SPORTSBOOKS = [
	{ label: '888sport', value: '888sport' },
	{ label: 'Bally Bet', value: 'Bally Bet' },
	{ label: 'BET99', value: 'BET99' },
	{ label: 'BetAnySports', value: 'BetAnySports' },
	{ label: 'BetDSI', value: 'BetDSI' },
	{ label: 'BetMGM', value: 'BetMGM' },
	{ label: 'BetOnline', value: 'BetOnline' },
	{ label: 'BetOpenly', value: 'BetOpenly' },
	{ label: 'BetRivers', value: 'BetRivers' },
	{ label: 'BetUS', value: 'BetUS' },
	{ label: 'BetVictor', value: 'BetVictor' },
	{ label: 'Betano', value: 'Betano' },
	{ label: 'Betcris', value: 'Betcris' },
	{ label: 'bet365', value: 'bet365' },
	{ label: 'Betfair Exchange', value: 'Betfair Exchange' },
	{ label: 'Betfred', value: 'Betfred' },
	{ label: 'Betly', value: 'Betly' },
	{ label: 'Betplay', value: 'Betplay' },
	{ label: 'Betr Picks', value: 'Betr Picks' },
	{ label: 'betPARX', value: 'betPARX' },
	{ label: 'Betway', value: 'Betway' },
	{ label: 'betwhale', value: 'betwhale' },
	{ label: 'Bodog', value: 'Bodog' },
	{ label: 'BookMaker', value: 'BookMaker' },
	{ label: 'Bovada', value: 'Bovada' },
	{ label: 'Caesars', value: 'Caesars' },
	{ label: 'Circa Vegas', value: 'Circa Vegas' },
	{ label: 'Dabble', value: 'Dabble' },
	{ label: 'Desert Diamond', value: 'Desert Diamond' },
	{ label: 'DraftKings', value: 'DraftKings' },
	{ label: 'ESPN BET', value: 'ESPN BET' },
	{ label: 'FanDuel', value: 'FanDuel' },
	{ label: 'Fanatics', value: 'Fanatics' },
	{ label: 'FireKeepers', value: 'FireKeepers' },
	{ label: 'Fliff', value: 'Fliff' },
	{ label: 'Golden Nugget', value: 'Golden Nugget' },
	{ label: 'Hard Rock', value: 'Hard Rock' },
	{ label: 'HotStreak', value: 'HotStreak' },
	{ label: 'JuiceBet', value: 'JuiceBet' },
	{ label: 'Kambi', value: 'Kambi' },
	{ label: 'LeoVegas', value: 'LeoVegas' },
	{ label: 'MyBookie', value: 'MyBookie' },
	{ label: 'NorthStar Bets', value: 'NorthStar Bets' },
	{ label: 'Novig', value: 'Novig' },
	{ label: 'ParlayPlay', value: 'ParlayPlay' },
	{ label: 'Pinnacle', value: 'Pinnacle' },
	{ label: 'Play Alberta', value: 'Play Alberta' },
	{ label: 'PlayNow', value: 'PlayNow' },
	{ label: 'PointsBet', value: 'PointsBet' },
	{ label: 'PrizePicks', value: 'PrizePicks' },
	{ label: 'Proline', value: 'Proline' },
	{ label: 'ProphetX', value: 'ProphetX' },
	{ label: 'Props Builder', value: 'Props Builder' },
	{ label: 'Rebet', value: 'Rebet' },
	{ label: 'Resorts World Bet', value: 'Resorts World Bet' },
	{ label: 'Sleeper', value: 'Sleeper' },
	{ label: 'Sporttrade', value: 'Sporttrade' },
	{ label: 'Sportzino', value: 'Sportzino' },
	{ label: 'Stake', value: 'Stake' },
	{ label: 'SuperBook', value: 'SuperBook' },
	{ label: 'theScore', value: 'theScore' },
	{ label: 'Thrillzz', value: 'Thrillzz' },
	{ label: 'Tipico', value: 'Tipico' },
	{ label: 'TonyBet', value: 'TonyBet' },
	{ label: 'Underdog Fantasy', value: 'Underdog Fantasy' },
	{ label: 'Underdog Sportsbook', value: 'Underdog Sportsbook' },
	{ label: 'Unibet', value: 'Unibet' },
];

export const DEFAULT_SPORTSBOOKS = [
	{ label: '888sport', value: '888sport' },
	{ label: 'Bally Bet', value: 'Bally Bet' },
	{ label: 'BET99', value: 'BET99' },
	// { label: 'BetAnySports', value: 'BetAnySports' },
	// { label: 'BetDSI', value: 'BetDSI' },
	{ label: 'BetMGM', value: 'BetMGM' },
	// { label: 'BetOnline', value: 'BetOnline' },
	// { label: 'BetOpenly', value: 'BetOpenly' },
	// { label: 'BetRivers', value: 'BetRivers' },
	{ label: 'BetUS', value: 'BetUS' },
	// { label: 'BetVictor', value: 'BetVictor' },
	{ label: 'Betano', value: 'Betano' },
	// { label: 'Betcris', value: 'Betcris' },
	// { label: 'bet105', value: 'bet105' },
	{ label: 'bet365', value: 'bet365' },
	// { label: 'Betfair Exchange', value: 'Betfair Exchange' },
	// { label: 'Betfred', value: 'Betfred' },
	// { label: 'Betly', value: 'Betly' },
	// { label: 'Betplay', value: 'Betplay' },
	// { label: 'Betr Picks', value: 'Betr Picks' },
	// { label: 'betPARX', value: 'betPARX' },
	// { label: 'Betway', value: 'Betway' },
	// { label: 'betwhale', value: 'betwhale' },
	// { label: 'Bodog', value: 'Bodog' },
	{ label: 'BookMaker', value: 'BookMaker' },
	{ label: 'Bovada', value: 'Bovada' },
	{ label: 'Caesars', value: 'Caesars' },
	{ label: 'Circa Vegas', value: 'Circa Vegas' },
	// { label: 'Dabble', value: 'Dabble' },
	// { label: 'Desert Diamond', value: 'Desert Diamond' },
	{ label: 'DraftKings', value: 'DraftKings' },
	{ label: 'ESPN BET', value: 'ESPN BET' },
	{ label: 'FanDuel', value: 'FanDuel' },
	{ label: 'Fanatics', value: 'Fanatics' },
	// { label: 'FireKeepers', value: 'FireKeepers' },
	// { label: 'Fliff', value: 'Fliff' },
	// { label: 'Golden Nugget', value: 'Golden Nugget' },
	// { label: 'Hard Rock', value: 'Hard Rock' },
	// { label: 'HotStreak', value: 'HotStreak' },
	// { label: 'JuiceBet', value: 'JuiceBet' },
	// { label: 'Kambi', value: 'Kambi' },
	// { label: 'LeoVegas', value: 'LeoVegas' },
	// { label: 'MyBookie', value: 'MyBookie' },
	// { label: 'NorthStar Bets', value: 'NorthStar Bets' },
	{ label: 'Novig', value: 'Novig' },
	// { label: 'ParlayPlay', value: 'ParlayPlay' },
	{ label: 'Pinnacle', value: 'Pinnacle' },
	{ label: 'Play Alberta', value: 'Play Alberta' },
	// { label: 'PlayNow', value: 'PlayNow' },
	{ label: 'PointsBet', value: 'PointsBet' },
	{ label: 'PrizePicks', value: 'PrizePicks' },
	{ label: 'Proline', value: 'Proline' },
	// { label: 'ProphetX', value: 'ProphetX' },
	// { label: 'Props Builder', value: 'Props Builder' },
	// { label: 'Rebet', value: 'Rebet' },
	// { label: 'Resorts World Bet', value: 'Resorts World Bet' },
	// { label: 'Sleeper', value: 'Sleeper' },
	// { label: 'Sporttrade', value: 'Sporttrade' },
	// { label: 'Sportzino', value: 'Sportzino' },
	// { label: 'Stake', value: 'Stake' },
	{ label: 'SuperBook', value: 'SuperBook' },
	{ label: 'theScore', value: 'theScore' },
	// { label: 'Thrillzz', value: 'Thrillzz' },
	// { label: 'Tipico', value: 'Tipico' },
	// { label: 'TonyBet', value: 'TonyBet' },
	// { label: 'Underdog Fantasy', value: 'Underdog Fantasy' },
	// { label: 'Underdog Sportsbook', value: 'Underdog Sportsbook' },
	// { label: 'Unibet', value: 'Unibet' },
];

export const SPORTSBOOK_NAMES = [
	'888sport',
	'Bally Bet',
	'BET99',
	'BetAnySports',
	'BetDSI',
	'BetMGM',
	'BetOnline',
	'BetOpenly',
	'BetRivers',
	'BetUS',
	'BetVictor',
	'Betano',
	'Betcris',
	'Betfair Exchange',
	'Betfred',
	'Betly',
	'Betplay',
	'Betr Picks',
	'Betway',
	'Bodog',
	'BookMaker',
	'Bovada',
	'Caesars',
	'Circa Vegas',
	'Dabble',
	'Desert Diamond',
	'DraftKings',
	'ESPN BET',
	'FanDuel',
	'Fanatics',
	'FireKeepers',
	'Fliff',
	'Golden Nugget',
	'Hard Rock',
	'HotStreak',
	'JuiceBet',
	'Kambi',
	'LeoVegas',
	'MyBookie',
	'NorthStar Bets',
	'Novig',
	'ParlayPlay',
	'Pinnacle',
	'Play Alberta',
	'PlayNow',
	'PointsBet',
	'PrizePicks',
	'Proline',
	'ProphetX',
	'Rebet',
	'Resorts World Bet',
	'Sleeper',
	'Sporttrade',
	'Sportzino',
	'Stake',
	'SuperBook',
	'Thrillzz',
	'Tipico',
	'TonyBet',
	'Underdog Fantasy',
	'Underdog Sportsbook',
	'Unibet',
	'bet365',
	'betPARX',
	'betwhale',
	'theScore',
	'Props Builder',
];

export const MARKETS = [
	'1st 10 Minutes Moneyline',
	'1st 10 Minutes Moneyline 3-Way',
	'1st 10 Minutes Puck Line',
	'1st 10 Minutes Total Corners',
	'1st 10 Minutes Total Goals',
	'1st 2 Innings Moneyline 3-Way',
	'1st 2 Maps Player Assists',
	'1st 2 Maps Player Fantasy Score (Underdog)',
	'1st 2 Maps Player Headshots',
	'1st 2 Maps Player Kills',
	'1st 2 Maps Player Kills (Combo)',
	'1st 3 Innings Moneyline',
	'1st 3 Innings Moneyline 3-Way',
	'1st 3 Innings Run Line',
	'1st 3 Innings Team Total',
	'1st 3 Innings Total Runs',
	'1st 3 Maps Player Assists',
	'1st 3 Maps Player Deaths',
	'1st 3 Maps Player Fantasy Score (Underdog)',
	'1st 3 Maps Player Kills',
	'1st 3 Quarters Moneyline',
	'1st 3 Quarters Moneyline 3-Way',
	'1st 3 Quarters Point Spread',
	'1st 3 Quarters Total Points',
	'1st 4 Innings Moneyline 3-Way',
	'1st 5 Minutes Total Goals',
	'1st 6 Innings Moneyline 3-Way',
	'1st 7 Innings Moneyline',
	'1st 7 Innings Moneyline 3-Way',
	'1st 7 Innings Run Line',
	'1st 7 Innings Team Total',
	'1st 7 Innings Total Runs',
	'1st Half Anytime Touchdown Scorer',
	'1st Half Asian Handicap',
	'1st Half Asian Handicap Corners',
	'1st Half Asian Total Goals',
	'1st Half Both Teams To Score',
	'1st Half Clean Sheet',
	'1st Half Correct Score',
	'1st Half Double Chance',
	'1st Half Draw No Bet',
	'1st Half First Team To Score',
	'1st Half Goal Spread',
	'1st Half Goal Spread 3-Way',
	'1st Half Goal To Be Scored',
	'1st Half Last Team To Score',
	'1st Half Moneyline',
	'1st Half Moneyline 3-Way',
	'1st Half Most Corners 3-Way',
	'1st Half Player Passing Touchdowns',
	'1st Half Player Passing Yards',
	'1st Half Player Points',
	'1st Half Player Points + Rebounds + Assists',
	'1st Half Player Receiving Yards',
	'1st Half Player Rushing Yards',
	'1st Half Player Shots On Target',
	'1st Half Player Touchdowns',
	'1st Half Point Spread',
	'1st Half Race To 20 Points',
	'1st Half Race To 25 Points',
	'1st Half Race To 30 Points',
	'1st Half Race To 35 Points',
	'1st Half Race To 40 Points',
	'1st Half Race To 45 Points',
	'1st Half Race To 50 Points',
	'1st Half Race To 55 Points',
	'1st Half Race To 60 Points',
	'1st Half Run Line',
	'1st Half Team To Score',
	'1st Half Team Total',
	'1st Half Team Total Cards',
	'1st Half Team Total Corners',
	'1st Half Team Total Field Goals',
	'1st Half Team Total Goals',
	'1st Half Team Total Goals Odd/Even',
	'1st Half Team Total Hits',
	'1st Half Team Total Odd/Even',
	'1st Half Team Total Touchdowns',
	'1st Half Total Cards',
	'1st Half Total Corners',
	'1st Half Total Corners 3-Way',
	'1st Half Total Corners Odd/Even',
	'1st Half Total Field Goals',
	'1st Half Total Goals',
	'1st Half Total Goals 3-Way',
	'1st Half Total Goals Exact',
	'1st Half Total Goals Odd/Even',
	'1st Half Total Hits',
	'1st Half Total Points',
	'1st Half Total Points Odd/Even',
	'1st Half Total Runs',
	'1st Half Total Touchdowns',
	'1st Half Will There Be A Red Card',
	'1st Inning Correct Score',
	'1st Inning Moneyline',
	'1st Inning Moneyline 3-Way',
	'1st Inning Most Hits 3-Way',
	'1st Inning Run Line',
	'1st Inning Team To Score',
	'1st Inning Team Total',
	'1st Inning Team Total Hits',
	'1st Inning Team Total Home Runs',
	'1st Inning Team Total Pitches Thrown',
	'1st Inning Team Total Strikeouts',
	'1st Inning Total Hits',
	'1st Inning Total Runs',
	'1st Inning Total Runs Exact',
	'1st Inning Total Runs Odd/Even',
	'1st Map Asian Handicap',
	'1st Map Betting',
	'1st Map First Elemental Dragon',
	'1st Map Kills Handicap',
	'1st Map Moneyline',
	'1st Map Player Deaths',
	'1st Map Player Fantasy Score (Underdog)',
	'1st Map Player Kills',
	'1st Map Round Handicap',
	'1st Map Team Destroy First Inhibitor',
	'1st Map Team First Baron',
	'1st Map Team First Blood',
	'1st Map Team Total',
	'1st Map Team Total Kills',
	'1st Map Total Barons Slain',
	'1st Map Total Inhibitors Destroyed',
	'1st Map Total Kills',
	'1st Map Total Kills Odd/Even',
	'1st Map Total Rounds',
	'1st Map Total Rounds Odd/Even',
	'1st Period Anytime Goal Scorer',
	'1st Period Both Teams To Score',
	'1st Period Correct Score',
	'1st Period Double Chance',
	'1st Period Draw No Bet',
	'1st Period First Goal',
	'1st Period First Goal Scorer',
	'1st Period First Team To Score',
	'1st Period First Team To Score 3-Way',
	'1st Period Last Goal Scorer',
	'1st Period Last Team To Score',
	'1st Period Last Team To Score 3-Way',
	'1st Period Moneyline',
	'1st Period Moneyline 3-Way',
	'1st Period Player Goals',
	'1st Period Player Saves',
	'1st Period Puck Line',
	'1st Period Team Total',
	'1st Period Total Goals',
	'1st Period Total Goals Odd/Even',
	'1st Quarter Anytime Touchdown Scorer',
	'1st Quarter Both Teams To Score',
	'1st Quarter Correct Score',
	'1st Quarter Double Chance',
	'1st Quarter First Team To Score',
	'1st Quarter Moneyline',
	'1st Quarter Moneyline 3-Way',
	'1st Quarter Player Assists',
	'1st Quarter Player Passing Touchdowns',
	'1st Quarter Player Passing Yards',
	'1st Quarter Player Points',
	'1st Quarter Player Rebounds',
	'1st Quarter Player Receiving Yards',
	'1st Quarter Player Rushing Yards',
	'1st Quarter Player Touchdowns',
	'1st Quarter Point Spread',
	'1st Quarter Race To 10 Points',
	'1st Quarter Race To 15 Points',
	'1st Quarter Race To 20 Points',
	'1st Quarter Team Total',
	'1st Quarter Team Total Odd/Even',
	'1st Quarter Team Total Touchdowns',
	'1st Quarter Total Points',
	'1st Quarter Total Points Odd/Even',
	'1st Quarter Total Touchdowns',
	'1st Set Betting',
	'1st Set Correct Score',
	'1st Set Game Spread',
	'1st Set Moneyline',
	'1st Set Most Aces',
	'1st Set Total Aces',
	'1st Set Total Games',
	'1st Set Total Games Odd/Even',
	'2nd Half Anytime Touchdown Scorer',
	'2nd Half Asian Handicap',
	'2nd Half Asian Handicap Corners',
	'2nd Half Asian Total Goals',
	'2nd Half Both Teams To Score',
	'2nd Half Correct Score',
	'2nd Half Double Chance',
	'2nd Half Draw No Bet',
	'2nd Half First Team To Score',
	'2nd Half Goal Spread',
	'2nd Half Goal Spread 3-Way',
	'2nd Half Goal To Be Scored',
	'2nd Half Last Team To Score',
	'2nd Half Moneyline',
	'2nd Half Moneyline 3-Way',
	'2nd Half Moneyline 3-Way Reg Time',
	'2nd Half Most Corners 3-Way',
	'2nd Half Point Spread',
	'2nd Half Point Spread Reg Time',
	'2nd Half Team To Score',
	'2nd Half Team Total',
	'2nd Half Team Total Cards',
	'2nd Half Team Total Corners',
	'2nd Half Team Total Field Goals',
	'2nd Half Team Total Goals',
	'2nd Half Team Total Goals Odd/Even',
	'2nd Half Team Total Odd/Even',
	'2nd Half Team Total Touchdowns',
	'2nd Half Total Corners',
	'2nd Half Total Corners Odd/Even',
	'2nd Half Total Field Goals',
	'2nd Half Total Goals',
	'2nd Half Total Goals 3-Way',
	'2nd Half Total Goals Odd/Even',
	'2nd Half Total Points',
	'2nd Half Total Points Odd/Even',
	'2nd Half Total Touchdowns',
	'2nd Half Will There Be A Red Card',
	'2nd Inning Correct Score',
	'2nd Inning Moneyline',
	'2nd Inning Moneyline 3-Way',
	'2nd Inning Run Line',
	'2nd Inning Total Hits',
	'2nd Inning Total Runs',
	'2nd Inning Total Runs Exact',
	'2nd Inning Total Runs Odd/Even',
	'2nd Map Asian Handicap',
	'2nd Map Betting',
	'2nd Map First Elemental Dragon',
	'2nd Map Kills Handicap',
	'2nd Map Moneyline',
	'2nd Map Player Fantasy Score (Underdog)',
	'2nd Map Player Kills',
	'2nd Map Round Handicap',
	'2nd Map Team Destroy First Inhibitor',
	'2nd Map Team First Baron',
	'2nd Map Team First Blood',
	'2nd Map Team Total',
	'2nd Map Team Total Kills',
	'2nd Map Total Barons Slain',
	'2nd Map Total Inhibitors Destroyed',
	'2nd Map Total Kills',
	'2nd Map Total Kills Odd/Even',
	'2nd Map Total Rounds',
	'2nd Map Total Rounds Odd/Even',
	'2nd Period Anytime Goal Scorer',
	'2nd Period Both Teams To Score',
	'2nd Period Correct Score',
	'2nd Period Double Chance',
	'2nd Period Draw No Bet',
	'2nd Period First Goal Scorer',
	'2nd Period First Team To Score 3-Way',
	'2nd Period Last Goal Scorer',
	'2nd Period Last Team To Score 3-Way',
	'2nd Period Moneyline',
	'2nd Period Moneyline 3-Way',
	'2nd Period Puck Line',
	'2nd Period Team Total',
	'2nd Period Total Goals',
	'2nd Period Total Goals Odd/Even',
	'2nd Quarter Anytime Touchdown Scorer',
	'2nd Quarter Both Teams To Score',
	'2nd Quarter Correct Score',
	'2nd Quarter Moneyline',
	'2nd Quarter Moneyline 3-Way',
	'2nd Quarter Point Spread',
	'2nd Quarter Team Total',
	'2nd Quarter Team Total Odd/Even',
	'2nd Quarter Team Total Touchdowns',
	'2nd Quarter Total Points',
	'2nd Quarter Total Points Odd/Even',
	'2nd Quarter Total Touchdowns',
	'2nd Round Handicap',
	'2nd Round Moneyline',
	'2nd Set Betting',
	'2nd Set Correct Score',
	'2nd Set Game Spread',
	'2nd Set Moneyline',
	'2nd Set Most Aces',
	'2nd Set Total Aces',
	'2nd Set Total Games',
	'2nd Set Total Games Odd/Even',
	'3rd Inning Correct Score',
	'3rd Inning Moneyline',
	'3rd Inning Moneyline 3-Way',
	'3rd Inning Run Line',
	'3rd Inning Total Hits',
	'3rd Inning Total Runs',
	'3rd Inning Total Runs Odd/Even',
	'3rd Map Asian Handicap',
	'3rd Map First Elemental Dragon',
	'3rd Map Kills Handicap',
	'3rd Map Moneyline',
	'3rd Map Player Headshots',
	'3rd Map Player Kills',
	'3rd Map Round Handicap',
	'3rd Map Team Destroy First Inhibitor',
	'3rd Map Team First Baron',
	'3rd Map Team First Blood',
	'3rd Map Team Total',
	'3rd Map Team Total Kills',
	'3rd Map Total Barons Slain',
	'3rd Map Total Kills',
	'3rd Map Total Kills Odd/Even',
	'3rd Map Total Rounds',
	'3rd Map Total Rounds Odd/Even',
	'3rd Period Anytime Goal Scorer',
	'3rd Period Both Teams To Score',
	'3rd Period Correct Score',
	'3rd Period Double Chance',
	'3rd Period Draw No Bet',
	'3rd Period First Goal Scorer',
	'3rd Period First Team To Score 3-Way',
	'3rd Period Last Team To Score 3-Way',
	'3rd Period Moneyline',
	'3rd Period Moneyline 3-Way',
	'3rd Period Puck Line',
	'3rd Period Team Total',
	'3rd Period Total Goals',
	'3rd Period Total Goals Odd/Even',
	'3rd Quarter Anytime Touchdown Scorer',
	'3rd Quarter Both Teams To Score',
	'3rd Quarter Correct Score',
	'3rd Quarter Moneyline',
	'3rd Quarter Moneyline 3-Way',
	'3rd Quarter Point Spread',
	'3rd Quarter Team Total',
	'3rd Quarter Team Total Odd/Even',
	'3rd Quarter Team Total Touchdowns',
	'3rd Quarter Total Points',
	'3rd Quarter Total Points Odd/Even',
	'3rd Quarter Total Touchdowns',
	'3rd Set Betting',
	'3rd Set Game Spread',
	'3rd Set Moneyline',
	'3rd Set Most Aces',
	'3rd Set Total Aces',
	'3rd Set Total Games',
	'3rd Set Total Games Odd/Even',
	'4th Inning Correct Score',
	'4th Inning Moneyline',
	'4th Inning Moneyline 3-Way',
	'4th Inning Run Line',
	'4th Inning Total Hits',
	'4th Inning Total Runs',
	'4th Inning Total Runs Odd/Even',
	'4th Map Kills Handicap',
	'4th Map Moneyline',
	'4th Map Team Total Kills',
	'4th Map Total Kills',
	'4th Quarter Anytime Touchdown Scorer',
	'4th Quarter Both Teams To Score',
	'4th Quarter Correct Score',
	'4th Quarter Moneyline',
	'4th Quarter Moneyline 3-Way',
	'4th Quarter Point Spread',
	'4th Quarter Team Total',
	'4th Quarter Team Total Odd/Even',
	'4th Quarter Team Total Touchdowns',
	'4th Quarter Total Points',
	'4th Quarter Total Points Odd/Even',
	'4th Quarter Total Touchdowns',
	'5th Inning Correct Score',
	'5th Inning Moneyline 3-Way',
	'5th Inning Run Line',
	'5th Inning Total Hits',
	'5th Inning Total Runs',
	'5th Inning Total Runs Odd/Even',
	'5th Map Kills Handicap',
	'5th Map Moneyline',
	'5th Map Team Total Kills',
	'5th Map Total Kills',
	'6th Inning Correct Score',
	'6th Inning Moneyline 3-Way',
	'6th Inning Run Line',
	'6th Inning Total Hits',
	'6th Inning Total Runs',
	'6th Inning Total Runs Odd/Even',
	'7th Inning Correct Score',
	'7th Inning Moneyline 3-Way',
	'7th Inning Run Line',
	'7th Inning Total Hits',
	'7th Inning Total Runs',
	'7th Inning Total Runs Odd/Even',
	'8th Inning Correct Score',
	'8th Inning Moneyline 3-Way',
	'8th Inning Run Line',
	'8th Inning Total Hits',
	'8th Inning Total Runs',
	'8th Inning Total Runs Odd/Even',
	'9th Inning Moneyline 3-Way',
	'9th Inning Run Line',
	'9th Inning Total Runs',
	'Anytime Assist',
	'Anytime Card Receiver',
	'Anytime Goal Scorer',
	'Anytime Goal Scorer By Header',
	'Anytime Goal Scorer Outside Box',
	'Anytime Red Card Receiver',
	'Anytime Touchdown Scorer',
	'Asian Handicap',
	'Asian Handicap Card Points',
	'Asian Handicap Cards',
	'Asian Handicap Corners',
	'Asian Map Handicap',
	'Asian Team Total',
	'Asian Total Goals',
	'Both Players To Win A Set',
	'Both Teams To Receive A Card',
	'Both Teams To Receive A Red Card',
	'Both Teams To Score',
	'Both Teams To Score 2 Goals',
	'Both Teams To Score Both Halves',
	'Both Teams To Score In At Least One Half',
	'Both Teams To Score Reg Time',
	'Card Spread 3-Way',
	'Clean Sheet',
	'Corners Spread 3-Way',
	'Correct Score',
	'Correct Score Reg Time',
	'Decision No Bet',
	'Double Chance',
	'Double Chance Reg Time',
	'Draw In Both Halves',
	'Draw No Bet',
	'Draw No Bet Reg Time',
	'First Basket',
	'First Basket Including FT',
	'First Break Of Serve',
	'First Card',
	'First Card Receiver',
	'First Goal Reg Time',
	'First Goal Scorer',
	'First Home Run',
	'First Run',
	'First Team Basket',
	'First Team To Receive Card',
	'First Team To Score',
	'First Team To Score 3-Way',
	'First Touchdown Scorer',
	'Fourth Goal Scorer',
	'Game Spread',
	'Go The Distance',
	'Goal Both Halves',
	'Goal Spread',
	'Goal Spread 3-Way',
	'Halftime / Fulltime',
	'Highest Scoring Half',
	'Highest Scoring Inning',
	'Highest Scoring Period',
	'Highest Scoring Quarter',
	'Last Card',
	'Last Goal',
	'Last Goal Reg Time',
	'Last Goal Scorer',
	'Last Team To Score',
	'Last Team To Score 3-Way',
	'Last Touchdown Scorer',
	'Man Of The Match',
	'Map Betting',
	'Map Handicap',
	'Method Of Ending',
	'Method Of First Basket Including FT',
	'Method of Victory',
	'Moneyline',
	'Moneyline + Total Rounds',
	'Moneyline 3-Way',
	'Moneyline Reg Time',
	'Most Aces',
	'Most Cards 3-Way',
	'Most Corners 3-Way',
	'Most Fours',
	'Most Hits 3-Way',
	'Most Run Outs',
	'Most Shots 3-Way',
	'Most Shots On Target 3-Way',
	'Most Significant Strikes',
	'Most Sixes',
	'Most Takedowns',
	'No Runs First Inning',
	'Period With Most Goals',
	'Player Aces',
	'Player Assists',
	'Player Assists (Combo)',
	'Player Bases',
	'Player Batting Fantasy Score (PrizePicks)',
	'Player Batting Strikeouts',
	'Player Batting Walks',
	'Player Birdies Streak',
	'Player Blocked Shots',
	'Player Blocks',
	'Player Bounce Backs',
	'Player Break Points Won',
	'Player Cards',
	'Player Clearances',
	'Player Crosses',
	'Player Defensive Interceptions',
	'Player Defensive Rebounds',
	'Player Double Double',
	'Player Double Faults',
	'Player Doubles',
	'Player Dribble Attempts',
	'Player Eagles',
	'Player Earned Runs',
	'Player Extra Points Made',
	'Player Faceoffs Won',
	'Player Fantasy Score (All)',
	'Player Fantasy Score (Betr)',
	'Player Fantasy Score (ParlayPlay)',
	'Player Fantasy Score (PrizePicks)',
	'Player Fantasy Score (Underdog)',
	'Player Field Goal Yards (Combo)',
	'Player Field Goals Attempted',
	'Player Field Goals Made',
	'Player Field Goals Made (Combo)',
	'Player Fight Time Minutes',
	'Player First Downs',
	'Player First Hit',
	'Player First Run',
	'Player Fouls',
	'Player Fouls Drawn',
	'Player Free Throws Made',
	'Player Games Lost',
	'Player Games Won',
	'Player Goals',
	'Player Goals + Assists',
	'Player Goals Against',
	'Player Header Shots On Target',
	'Player Hits',
	'Player Hits + Runs + RBIs',
	'Player Hits Allowed',
	'Player Home Runs',
	'Player Home Runs Yes/No',
	'Player Interceptions',
	'Player Kicking Points',
	'Player Longest Field Goal (Combo)',
	'Player Longest Passing Completion',
	'Player Longest Reception',
	'Player Longest Rush',
	'Player Made Threes',
	'Player Made Threes (Combo)',
	'Player Offensive Rebounds',
	'Player Outs',
	'Player Outside Box Shots On Target',
	'Player Passing + Rushing Yards',
	'Player Passing Attempts',
	'Player Passing Completion Percentage',
	'Player Passing Completions',
	'Player Passing First Downs',
	'Player Passing Touchdowns',
	'Player Passing Yards',
	'Player Passing Yards (Combo)',
	'Player Pitching Fantasy Score (PrizePicks)',
	'Player Points',
	'Player Points (Combo)',
	'Player Points + Assists',
	'Player Points + Rebounds',
	'Player Points + Rebounds + Assists',
	'Player Power Play Points',
	'Player RBIs',
	'Player Rebounds',
	'Player Rebounds (Combo)',
	'Player Rebounds + Assists',
	'Player Receiving Targets',
	'Player Receiving Touchdowns',
	'Player Receiving Yards',
	'Player Receiving Yards (Combo)',
	'Player Receptions',
	'Player Runs',
	'Player Runs + RBIs',
	'Player Rushing + Receiving Yards',
	'Player Rushing + Receiving Yards (Combo)',
	'Player Rushing Attempts',
	'Player Rushing Touchdowns',
	'Player Rushing Yards',
	'Player Rushing Yards (Combo)',
	'Player Sacks',
	'Player Saves',
	'Player Saves (Combo)',
	'Player Sets Won',
	'Player Shots',
	'Player Shots Assisted',
	'Player Shots Attempted',
	'Player Shots On Goal',
	'Player Shots On Target',
	'Player Significant Strikes',
	'Player Singles',
	'Player Sixes',
	'Player Steals',
	'Player Steals + Blocks',
	'Player Stolen Bases',
	'Player Strikeouts',
	'Player Strikeouts (Combo)',
	'Player Tackles',
	'Player Tackles + Assists',
	'Player Takedowns',
	'Player Threes Attempted',
	'Player Time On Ice',
	'Player To Record Shutout',
	'Player To Record Win',
	'Player To Score Or Assist',
	'Player To Win A Set',
	'Player Touchdowns',
	'Player Touches',
	'Player Triple Double',
	'Player Triples',
	'Player Turnovers',
	'Player Walks',
	'Point Spread',
	'Point Spread 3-Way',
	'Puck Line',
	'Puck Line 3-Way',
	'Puck Line Reg Time',
	'Race To 10 Points',
	'Race To 12 Points',
	'Race To 15 Points',
	'Race To 20 Points',
	'Race To 25 Points',
	'Race To 3 Corners',
	'Race To 30 Points',
	'Race To 35 Points',
	'Race To 40 Points',
	'Race To 45 Points',
	'Race To 5 Corners',
	'Race To 5 Points',
	'Race To 50 Points',
	'Race To 6 Points',
	'Race To 7 Corners',
	'Race To 9 Corners',
	'Race To 9 Points',
	'Round Betting',
	'Round Handicap',
	'Run Line',
	'Run Line 3-Way',
	'Second Goal Scorer',
	'Set Betting',
	'Set Handicap',
	'Set With Most Games',
	'Team Clean Sheet',
	'Team Highest Scoring Half',
	'Team Highest Scoring Inning',
	'Team Highest Scoring Inning 3-Way',
	'Team Highest Scoring Period',
	'Team Highest Scoring Quarter',
	'Team Last Goal Scorer',
	'Team To Kick First Corner',
	'Team To Kick Last Corner',
	'Team To Miss Penalty',
	'Team To Score',
	'Team To Score Both Halves',
	'Team To Score Penalty',
	'Team To Win Both Halves',
	'Team To Win Either Half',
	'Team To Win From Behind',
	'Team To Win Most Innings',
	'Team To Win To Nil',
	'Team Total',
	'Team Total 3-Way',
	'Team Total Card Points',
	'Team Total Cards',
	'Team Total Consecutive Points',
	'Team Total Corners',
	'Team Total Exact',
	'Team Total Field Goals',
	'Team Total Fouls',
	'Team Total Goal Minutes',
	'Team Total Goals',
	'Team Total Goals Exact',
	'Team Total Goals Odd/Even',
	'Team Total Hits',
	'Team Total Home Runs',
	'Team Total Odd/Even',
	'Team Total Offsides',
	'Team Total Passing Attempts',
	'Team Total Passing Touchdowns',
	'Team Total Points Odd/Even',
	'Team Total Reg Time',
	'Team Total Rushing Touchdowns',
	'Team Total Sacks',
	'Team Total Shots',
	'Team Total Shots On Target',
	'Team Total Tackles',
	'Team Total Touchdowns',
	'Team With Most Hits',
	'Third Goal Scorer',
	'To Lift The Cup',
	'To Qualify',
	'To Win 1st Set',
	'To Win The Toss',
	'Top Batsman',
	'Top Bowler',
	'Total Aces',
	'Total Card Points',
	'Total Cards',
	'Total Corners',
	'Total Corners 3-Way',
	'Total Corners Odd/Even',
	'Total Double Faults',
	'Total Field Goals',
	'Total First Downs',
	'Total Games',
	'Total Games Odd/Even',
	'Total Goal Minutes',
	'Total Goals',
	'Total Goals 3-Way',
	'Total Goals Exact',
	'Total Goals Odd/Even',
	'Total Goals Odd/Even Reg Time',
	'Total Goals Reg Time',
	'Total Hits',
	'Total Hits + Runs + Errors',
	'Total Home Runs Odd/Even',
	'Total Kills',
	'Total Maps',
	'Total Maps Odd/Even',
	'Total Offsides',
	'Total Points',
	'Total Points Odd/Even',
	'Total Punts',
	'Total Red Cards',
	'Total Rounds',
	'Total Runs',
	'Total Runs 3-Way',
	'Total Runs Odd/Even',
	'Total Sacks',
	'Total Sets',
	'Total Shots',
	'Total Shots On Target',
	'Total Tie Breaks',
	'Total Tiebreaks',
	'Total Touchdowns',
	'Total Turnovers',
	'Will A Point Be Deducted',
	'Will Fight End In First Minute',
	'Will There Be A Century',
	'Will There Be A Fifty',
	'Will There Be A Penalty',
	'Will There Be A Red Card',
	'Will There Be A Safety',
	'Will There Be A Tiebreak',
	'Will There Be An Own Goal',
	'Will There Be Overtime',
	'Winner And Exact Round',
	'Winning Margin 5-Way',
	'Winning Margin Reg Time',
	'Winning Round',
];

// Helper function to check if sharp books are set to default values
export const isDefaultSharpBooks = (sharpBooks) => {
	if (!sharpBooks || !Array.isArray(sharpBooks)) return false;
	
	const defaultValues = [
		{ label: 'WagerWiz Props', value: 'WagerWiz Props' },
		{ label: 'WagerWiz Mains', value: 'WagerWiz Mains' }
	];
	
	if (sharpBooks.length !== defaultValues.length) return false;
	
	return defaultValues.every(defaultBook => 
		sharpBooks.some(book => 
			book.value === defaultBook.value && book.label === defaultBook.label
		)
	);
};

// Helper function to get WagerWiz display options (shows as single "WagerWiz" option)
export const getWagerWizDisplayOptions = () => {
	return [
		{ label: 'WagerWiz', value: 'WagerWiz' }
	];
};

// Helper function to get WagerWiz backend options (maintains separate Mains/Props for backend)
export const getWagerWizBackendOptions = () => {
	return [
		{ label: 'WagerWiz Mains', value: 'WagerWiz Mains' },
		{ label: 'WagerWiz Props', value: 'WagerWiz Props' }
	];
};

// Helper function to convert WagerWiz selection to backend values
export const convertWagerWizSelectionToBackend = (selectedOptions) => {
	if (!selectedOptions || !Array.isArray(selectedOptions)) return selectedOptions;
	
	return selectedOptions.map(option => {
		if (option.value === 'WagerWiz') {
			// Return both Mains and Props when WagerWiz is selected
			return [
				{ label: 'WagerWiz Mains', value: 'WagerWiz Mains' },
				{ label: 'WagerWiz Props', value: 'WagerWiz Props' }
			];
		}
		return option;
	}).flat();
};

// Helper function to convert backend values to WagerWiz display
export const convertBackendToWagerWizDisplay = (backendOptions) => {
	if (!backendOptions || !Array.isArray(backendOptions)) return backendOptions;
	
	const hasWagerWizMains = backendOptions.some(option => option.value === 'WagerWiz Mains');
	const hasWagerWizProps = backendOptions.some(option => option.value === 'WagerWiz Props');
	
	// If either Mains or Props (or both) are selected, show as single WagerWiz option
	if (hasWagerWizMains || hasWagerWizProps) {
		return [
			{ label: 'WagerWiz', value: 'WagerWiz' },
			...backendOptions.filter(option => option.value !== 'WagerWiz Mains' && option.value !== 'WagerWiz Props')
		];
	}
	
	return backendOptions;
};

// Helper function to get display value for sharp books (empty if defaults)
export const getSharpBooksDisplayValue = (sharpBooks) => {
	return isDefaultSharpBooks(sharpBooks) ? [] : (sharpBooks || []);
};

// Helper function to count sharp books for display purposes
// WagerWiz (whether Mains, Props, or both) counts as 1
export const getSharpBooksDisplayCount = (backendOptions) => {
	if (!backendOptions || !Array.isArray(backendOptions)) return 0;
	
	const displayOptions = convertBackendToWagerWizDisplay(backendOptions);
	return displayOptions ? displayOptions.length : 0;
};
